// Polyfill crypto.randomUUID for non-HTTPS contexts (e.g. mobile on local network)
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
  crypto.randomUUID = () =>
    '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, c =>
      (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
    );
}

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import '../nnaico.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />,
)
